<template lang="pug">
    component(:is="dialogMode ? 'div' : 'd2-container'")
        el-form(:inline='true', :model='dataForm' size='mini' label-width='80px' label-position='left' :modal-append-to-body='false' label-suffix=':')
            el-row(:span='24')
                el-col(:md='6' :sm='12')
                    el-form-item(label='课程日期')
                        el-date-picker.inputWidth(style='width:210px;' v-model='dataForm.classDate' type='date' placeholder='请选择日期' value-format='yyyy-MM-dd' clearable)
                el-col(:md='6' :sm='12')
                    el-form-item(label='课程状态')
                        el-select.inputWidth(v-model='dataForm.state' clearable)
                            el-option(label='未开始' :value='0')
                            el-option(label='进行中' :value='1')
                            el-option(label='已结束' :value='2')
            el-row(style="padding-bottom:15px;" :span='24')
                el-col(:md='23' :sm='5')
                    el-button(@click='addOrUpdateHandle()' type='primary' v-if="isAuth('px:course:add')") 新建课程
                el-col(:md='1' :sm='14' style='float:right;')
                    el-button(@click='queryList()' type='primary' icon='el-icon-search' style='float:right;') 查 询
        el-table(:data='tableData' style='width: 100%' v-loading='dataListLoading' border)
            el-table-column(prop='id' header-align='center' align='center' label='课程ID' width='150')
            el-table-column(prop='code' header-align='center' align='center' label='课次' width='70')
            el-table-column(prop='groupName' header-align='center' align='center' label='所属培训组' :show-overflow-tooltip='true')
            el-table-column(prop='groupId' header-align='center' align='center' label='所属培训组id' width='100' :show-overflow-tooltip='true')
            el-table-column(prop='trainName' header-align='center' align='center' label='所属培训班' :show-overflow-tooltip='true')
            el-table-column(prop='trainTime' header-align='center' align='center' label='日期/时段' width='180')
                template(slot-scope='scope')
                    span {{ scope.row.trainTime || '' }}{{ (scope.row.trainTime && (scope.row.strTime || scope.row.endTime)) ? ' ' : '' }}{{ scope.row.strTime || '' }}{{ scope.row.endTime ? '-' + scope.row.endTime : '' }}
            el-table-column(prop='placeCode' header-align='center' align='center' label='场地' :show-overflow-tooltip='true')
            el-table-column(prop='coachName' header-align='center' align='center' label='教练' :show-overflow-tooltip='true')
            el-table-column(prop='classCount' header-align='center' align='center' label='班级容量/已报/剩余' width='160')
                template(slot-scope='scope')
                    span {{ scope.row.classCount || 0 }}/{{ scope.row.enrolledCount || 0 }}/{{ (scope.row.classCount || 0) - (scope.row.enrolledCount || 0) }}
            el-table-column(prop='courseStatus' header-align='center' align='center' label='课程状态' width='90')
                template(slot-scope='scope')
                    font(v-if='scope.row.courseStatus === 0') 未开始
                    font(v-if='scope.row.courseStatus === 1') 进行中
                    font(v-if='scope.row.courseStatus === 2') 已结束
            el-table-column(header-align='center' align='center' label='操作' width='180')
                template(slot-scope='scope')
                    el-button(type='text' size='mini' @click='userManage(scope.row)') 人员管理

        // 人员管理弹窗组件
        course-user-dialog(v-if='userDialogVisible' ref='courseUserDialog' @refresh='getTrainInfo')
</template>

<script>
import CourseUserDialog from './CourseUserDialog.vue'

export default {
  name: 'train-course',
  props: {
    dialogMode: {
      type: Boolean,
      default: false
    },
    initialTrainId: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    CourseUserDialog
  },
  watch: {
    '$route' (route) {
      if (this.dialogMode || route.name !== 'train-course') return
      const query = route.query || {}
      this.init(query.trainId)
    }
  },
  data () {
    return {
      trainId: '',
      trainInfo: {},
      isCollapse: true,
      tableData: [],
      dataListLoading: false,
      userDialogVisible: false,
      dataForm: {
        trainId: '',
        classDate: '',
        state: ''
    },
    // 培训记录
    trainRecord (row) {
      this.$router.push({
        name: 'train-course-record',
        query: { courseId: row.id, trainId: this.trainId }
      })
    }
  }
  },
  mounted () {
    if (this.dialogMode) {
      this.init(this.initialTrainId)
    } else {
      const query = this.$route.query || {}
      this.init(query.trainId)
    }
  },
  methods: {
    init (trainId) {
      this.trainId = trainId || ''
      this.dataForm.trainId = this.trainId
      this.dataForm.classDate = ''
      this.dataForm.state = ''
      this.tableData = []
      this.userDialogVisible = false
      this.getTrainInfo()
    },
    // 获取培训课程列表
    getTrainInfo () {
      if (!this.trainId) {
        this.trainInfo = {}
        this.tableData = []
        return
      }
      this.$http({
        url: this.$http.adornUrl('/pxTrain/queryCourseList'),
        method: 'post',
        data: {
          trainId: this.trainId,
          trainTime: this.dataForm.classDate,
          status: this.dataForm.state
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.list || []
        } else {
          this.tableData = []
        }
      }).catch(() => {
        this.tableData = []
      })
    },
    queryList () {
      this.getTrainInfo()
    },
    // 人员管理
    userManage (row) {
      this.userDialogVisible = true
      this.$nextTick(() => {
        this.$refs.courseUserDialog.init(row)
      })
    }
  }
}
</script>
<style>
@import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}
.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important;
}
.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}
.el-dialog {
  position: relative;
  margin: 0 auto 80px;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
}
</style>
